<template>
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 6L10 0.942651L9.06804 0L5 4.11472L0.931957 0L0 0.942651L5 6Z" fill="#888888"/>
  </svg>
</template>